export type RewardKlendMetricsEntity = {
  id: bigint;
  deposit_klend_reserve_id: number | null;
  borrow_klend_reserve_id: number | null;
  points_source_id: number;
  token_mint_id: number;
  created_on: Date;
  updated_on: Date;
  apy: string;
  tokens_per_second: string;
  usd_amount: string;
};
